// Getting all values
$(document).ready(function(){
  function getValuesFromUrl(){
    var url = String(window.location.href);
    var urlParameters = url.split('?');
    urlParameters = String(urlParameters[1]);
    // console.log(urlParameters, 'parametrai');

    $('.qz_primary_btn').each(function(){
      var currentUrl = $(this).attr('href');
      currentUrl = currentUrl + '?' + urlParameters;
      $(this).attr('href', currentUrl);
    });

    var allParameters = urlParameters.split('/');
    // console.log(allParameters);

    var sex = allParameters[0];
    var years = allParameters[1];
    var weightKg = allParameters[2];
    var weightLbs = allParameters[3];
    var heightCm = allParameters[4];
    var heightFt = allParameters[5];
    var heightIn = allParameters[6];
  
    var weigthMea = allParameters[7];
    var heigthMea = allParameters[8];

    var goal = allParameters[9];

    var weightInKilos = '';
    var heightInCm = '';
    var endWeight = '';
    // console.log(sex, '--' , years, '--' , weightKg, '--' , weightLbs, '--' , heightCm, '--' , heightFt, '--' , heightIn, '--' , weigthMea, '--' , heigthMea, 'LISTING');


    
    console.log('HEllo from line 34', goal);
    if (String(goal).indexOf('build') != -1){
      if (sex == 'female'){
        var build_musc = false;
      }
      else{
        var build_musc = true;
      }
      
    }
    else{
      var build_musc = false;
    }

    if (build_musc){
      $('.qz_hero_whole_out[data="build"]').show();
      $('.qzrs_table_image[data="build"]').show();
      $('.qzrs_announcment[data="build"]').show();
    }
    else{
      $('.qz_hero_whole_out[data="loose"]').show();
      $('.qzrs_table_image[data="loose"]').show();
      $('.qzrs_announcment[data="loose"]').show();
    }
    $('.qz_results_flex_Guide_section').hide();
    if (sex == 'male'){
      $('.qzrs_estimations').hide();
      $('.qzrs_estimations[data="men"]').show();
      $('.qzr_data--sex').html('Men');
      $('.qz_results_flex_Guide_section[data="male"]').show();
    }
    else if ( sex == 'female'){
      $('.qzrs_estimations').hide();
      $('.qzrs_estimations[data="women"]').show();
      $('.qzr_data--sex').html('Women');
      $('.qz_results_flex_Guide_section[data="female"]').show();
    }
    $('.qzr_data--years').html(years);
    if (heigthMea == 'ft'){
      var heightInInches = (parseFloat(heightFt) * 12) + parseFloat(heightIn);
      heightInCm = (heightInInches * 0.0254)* 100;
      $('.qzr_data--height').html('<strong>'+ heightFt+'`'+ heightIn +'</strong> ft');
    }
    else{
      heightInCm = heightCm;
      $('.qzr_data--height').html('<strong>'+ heightCm+ '</strong> cm');
    }
    if (weigthMea == 'lbs'){
      weightInKilos = weightLbs * 0.453592;
      $('.qzr_data--weight').html('<strong>'+ weightLbs+ '</strong> lbs');
      $('.qz_hero_stats_currentWeight').html(weightLbs + ' lbs');
      if (build_musc){
        endWeight = parseFloat(weightLbs) + 6.6;
      }
      else{
        endWeight = parseFloat(weightLbs) - 6.6;
      }
      
      $('.qz_hero_stats_endWeight').html(endWeight + ' lbs');
      $('.qz_stats_title').html(endWeight + 'lbs');
      if (build_musc){
        $('.qzrs_fw p').html('<span>+6.6</span>lbs');
      }
      else{
        $('.qzrs_fw p').html('<span>-6.6</span>lbs');
      }
      
      $('.qz_results_hero .qz_main_title span').html(6.6 + 'lbs');
    }
    else{
      weightInKilos = weightKg;
      $('.qzr_data--weight').html('<strong>'+ weightKg+ '</strong> kg');
      $('.qz_hero_stats_currentWeight').html(weightKg + ' kg');
      if (build_musc){
        endWeight = parseFloat(weightKg) + 2.9;
      }
      else{
        endWeight = parseFloat(weightKg) - 2.9;
      }
      
      $('.qz_stats_title').html(endWeight + 'kg');
      $('.qz_hero_stats_endWeight').html(endWeight + ' kg');
      if (build_musc){
        $('.qzrs_fw p').html('<span>+2.9</span>kg');
      }
      else{
        $('.qzrs_fw p').html('<span>-2.9</span>kg');
      }
      
      $('.qz_results_hero .qz_main_title span').html(2.9 + 'kg');
    }

    // console.log(weightInKilos, 'weightin kilos');
    // console.log(heightInCm, 'height in cm');
    var heightInCm = heightInCm / 100;

    var bmi = weightInKilos / (heightInCm * heightInCm);
    var bmiValue;
    if (bmi < 16.1){
       bmiValue = 'Underweight';
       var bmiColor = '#E0FFD7';
    }
    else if (bmi > 16 && bmi < 18.5){
       bmiValue = 'Low';
       var bmiColor = '#BBF0C2';
    }
    else if (bmi > 18.5 && bmi < 25.9){
       bmiValue = 'Healthy';
       var bmiColor = '#2EB934';
    }
    else if (bmi > 25.9 && bmi < 30){
       bmiValue = 'Overweight';
       var bmiColor = '#FFB9B8';
    }
    else if (bmi > 30){
       bmiValue = 'Obese';
       var bmiColor = '#FF0000';
    }
      
    bmi = bmi.toFixed(1);
    $('.qzrs_circle h3').html(bmi);
    $('.qzrs_circle p').html(bmiValue);
    $('.qzrs_circle').css('border', '10px solid '+bmiColor);

    // console.log(bmi, 'bmi index');

    var monthNames = [
        "January", "February", "March", "April", "May", "June",
        "July", "August", "September", "October", "November", "December"
    ];

    var currentDate = new Date();
    var currentMonthIndex = currentDate.getMonth();

    // Get current month
    var fullMonth = monthNames[currentMonthIndex];
    var shortMonth = fullMonth.substring(0, 3) + ".";

    // Get next month (handle December case by wrapping around)
    var nextMonthIndex = (currentMonthIndex + 1) % 12;
    var fullNextMonth = monthNames[nextMonthIndex];
    var shortNextMonth = fullNextMonth.substring(0, 3) + ".";

    console.log("Current Month: " + fullMonth + " (" + shortMonth + ")");
    console.log("Next Month: " + fullNextMonth + " (" + shortNextMonth + ")");

    $('.qzr_end_month').html(fullNextMonth);
    $('.qzr_curr_month').html(fullMonth);
    $('.qzr_end_month_short').html(shortNextMonth);

   
    
  }

  getValuesFromUrl();
});